import React, { useCallback, useMemo, useState } from "react";
import ServiceAccordion from "./ServiceAccordion";
import BundleServiceResume from "components/Bundles/BundleServiceResume";

export default function ExtraServices(props) {
  const [expanded, setExpanded] = useState();

  const {
    allExtraServices,
    selectedExtraServices,
    onSelectExtraService,
    onDeselectOptionalExtraServices,
    onOpenBundle,
    bundleTitle,
    bundleColorStyle,
    onRemoveBundle,
  } = props;

  const { requiredExtraServices, optionalExtraServices } = useMemo(() => {
    return {
      requiredExtraServices: allExtraServices.filter((x) => !x.optional),
      optionalExtraServices: allExtraServices.filter((x) => x.optional),
    };
  }, [allExtraServices]);

  const handleToggle = useCallback((title) => {
    setExpanded((prev) => {
      if (prev === title) {
        return undefined;
      }
      return title;
    });
  }, []);

  return (
    <div className="extra-list">
      {requiredExtraServices.map((extraservice, index) => {
        if (extraservice.isSelected) {
          return (
            <BundleServiceResume
              key={`required-${index}-${bundleTitle}`}
              serviceTitle={extraservice.title}
              bundleTitle={bundleTitle}
              colorStyle={bundleColorStyle}
              onRemove={onRemoveBundle}
            />
          );
        }

        return (
          <ServiceAccordion
            key={`required-${index}-${bundleTitle}`}
            service={extraservice}
            isExpanded={expanded === extraservice.title}
            onToggle={() => handleToggle(extraservice.title)}
            selectedExtraServices={selectedExtraServices}
            onSelect={onSelectExtraService}
            onDeselect={onDeselectOptionalExtraServices}
            onCtaClick={
              onOpenBundle
                ? () => {
                    handleToggle(extraservice.title);
                    onOpenBundle();
                  }
                : undefined
            }
            ctaLabel={bundleTitle}
          />
        );
      })}

      {optionalExtraServices.map((extraservice, index) => {
        if (extraservice.isSelected) {
          return (
            <BundleServiceResume
              key={`optional-${index}-${bundleTitle}`}
              serviceTitle={extraservice.title}
              bundleTitle={bundleTitle}
              colorStyle={bundleColorStyle}
              onRemove={onRemoveBundle}
            />
          );
        }

        return (
          <ServiceAccordion
            key={`optional-${index}-${bundleTitle}`}
            service={extraservice}
            isExpanded={expanded === extraservice.title}
            onToggle={() => handleToggle(extraservice.title)}
            selectedExtraServices={selectedExtraServices}
            onSelect={onSelectExtraService}
            onDeselect={onDeselectOptionalExtraServices}
            onCtaClick={
              onOpenBundle
                ? () => {
                    handleToggle(extraservice.title);
                    onOpenBundle();
                  }
                : undefined
            }
            ctaLabel={bundleTitle}
          />
        );
      })}
    </div>
  );
}
